import { Course } from './course.models';
import { Elo } from '@lyceo/shared/homi-settings/util-models';
export interface Task {
  id: string;
  type: TaskType;
  scheduledAt: string;
  course?: Course;
  title: string;
  position: number;
  doneAt?: string;
  pupilDoneAt?: string;
  elo?: Elo;
  parentTaskId?: string;
  estimatedDuration?: string;
  actualDuration?: string;
  studySkill?: TaskStudySkill;
  reflectionScore?: ReflectionScore;
  subTasks: Task[];
  taskNotes?: TaskNote[];
}

export interface TaskPosition {
  id: string;
  position: number;
  scheduledAt: string;
}

export interface TaskNote {
  id: string;
  taskId: string;
  type: string;
  value: string;
}

export interface LinkedTasks {
  [id: string]: string[];
}

export interface CalendarInfoTask {
  task: Task;
  priority: boolean;
  finished: boolean;
  linkedTasks: string[];
}

export enum TaskType {
  EXAM = 'EXAM',
  HAND_IN = 'HAND_IN',
  APPOINTMENT = 'APPOINTMENT',
  READ = 'READ',
  MAKE = 'MAKE',
  LEARN = 'LEARN',
  MAKE_AND_LEARN = 'MAKE_AND_LEARN',
  HOMEWORK = 'HOMEWORK',
  GOAL = 'GOAL',
  TEST = 'TEST',
}

export enum TaskStudySkill {
  MIND_MAPPING = 'MIND_MAPPING',
  QUIZ = 'QUIZ',
  REPEAT = 'REPEAT',
  TEST_QUESTIONS = 'TEST_QUESTIONS',
  FLASH_CARD = 'FLASH_CARD',
  SUMMARISE = 'SUMMARISE',
  THEMING = 'THEMING',
  DISCUSSION = 'DISCUSSION',
}

export enum ReflectionScore {
  BAD = 'BAD',
  MEH = 'MEH',
  NEUTRAL = 'NEUTRAL',
  GOOD = 'GOOD',
  SUPER = 'SUPER',
}
